import Vue from 'vue'
import VueRouter from 'vue-router'

// Routes
import { canNavigate } from '@/libs/acl/routeProtection'
import { isUserLoggedIn, getUserData, getHomeRouteForLoggedInUser } from '@/auth/utils'
// import apps from './routes/apps'
// import dashboard from './routes/dashboard'
// import my_panel from './routes/my_panel'
// import model_test from './routes/model_test'
// import studypress from './routes/studypress'
// import uiElements from './routes/ui-elements/index'
// import pages from './routes/pages'
// import chartsMaps from './routes/charts-maps'
// import formsTable from './routes/forms-tables'
// import others from './routes/others'
import myRoutes from './routes/route.js'
// import admin from './admin'

const newModifiedRoutes = myRoutes.map((item, index) => {
  item.id = []
  for (let index = 0; index < 3; index++) {
    // item.id.push(`index-1-child-${array[index]}`)
    for (let index2 = 0; index2 < 6; index2++) {
      item.id.push(`index-${index}-child-${index2}`)
    }
  }
  // item.id = ['index-1-child-0','index-2-child-0', 'index-3-child-0']
  return Object.assign(item)
})

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    ...newModifiedRoutes,
    // { path: '/dashboard', redirect: { name: 'dashboard' } },
    // ...apps,
    // ...dashboard,
    // ...my_panel,
    // ...model_test,
    // ...studypress,
    // ...pages,
    // ...chartsMaps,
    // ...formsTable,
    // ...uiElements,
    // ...others,
    {
      path: '*',
      component: () => import('@/views/error/Error404.vue'),
    },
  ],
})

// router.beforeEach((to, _, next) => {
//   const isLoggedIn = isUserLoggedIn()
//   // if (!isLoggedIn) return next({ name: 'auth-login' })
//   if (!canNavigate(to)) {
//     // Redirect to login if not logged in
//     if (!isLoggedIn) return next({ name: 'auth-login' })

//     // If logged in => not authorized
//     return next({ name: 'misc-not-authorized' })
//   }

//   // Redirect if logged in
//   if (to.meta.redirectIfLoggedIn && isLoggedIn) {
//     const userData = getUserData()
//     next(getHomeRouteForLoggedInUser(userData ? userData.role : null))
//   }

//   return next()
// })

// router.beforeEach((to, _, next) => {
//   const isLoggedIn = isUserLoggedIn()

//     if(to.name=='ResetPassword' || to.name=='ForgotPassword' || to.name=='admin_sign_in' || to.name=='') {
//       next();
//     } else if(to.name!=='auth-login' && !isLoggedIn) {
//       sessionStorage.setItem('redirectPath', to.path);
//       next({ name: 'auth-login' })
//     } else if(to.name=='auth-login' && isLoggedIn) {
//       next()
//     } else if(!to.meta.requiredAuth) {
//       next();
//     }

//   // Redirect if logged in
//   if (to.meta.redirectIfLoggedIn && isLoggedIn) {
//     const userData = getUserData()
//     next(getHomeRouteForLoggedInUser(userData ? userData.role : null))
//   }

//   return next()
// })

// router.beforeEach((to, _, next) => {
//   const isLoggedIn = isUserLoggedIn()
//   // if (!isLoggedIn) return next({ name: 'auth-login' })
//   if (!canNavigate(to)) {
//     if (to.name === 'admin_sign_in' &&  !isLoggedIn) {
//       return next({ name: 'admin_sign_in' })
//     }

//     if (to.name === 'admin_sign_in' &&  isLoggedIn) {
//       return next()
//     }

//     // if ((to.name === 'upgrade_pricing_page' || to.name === 'payment_page') &&  isLoggedIn) {
//     //   return next()
//     // }

//     // Redirect to login if not logged in
//     if (!isLoggedIn) return next({ name: 'auth-login' })

//     // If logged in => not authorized
//     next({ name: 'misc-not-authorized' })
//   }

//   // Redirect if logged in
//   if (to.meta.redirectIfLoggedIn && isLoggedIn) {
//     const userData = getUserData()
//     next(getHomeRouteForLoggedInUser(userData ? userData.role : null))
//   }

//   return next()
// })

router.beforeEach((to, from, next) => {
  // console.log('to=========', to)
  const isLoggedIn = isUserLoggedIn()
  // console.log('isLoggedIn', isLoggedIn)
  if (to.matched.some(record => record.meta.auth)) {
    if (isLoggedIn && to.name =='auth-login') {
        next('/site/dashboard');
    }

    if (isLoggedIn) {
        return next()
    }

    return next({ name: 'auth-login' })
  } else {
    if (isLoggedIn && (to.name =='auth-login' || to.name =='auth-register' || to.name == 'auth-forgot-password')) {
        next('/site/dashboard');
    } else {
      next()
    }
  }

})

// router.beforeEach((to, from, next)=>{

//   const isLoggedIn = isUserLoggedIn()

//   console.log('to.name', to.name)
  
//   if(to.name=='ResetPassword' || to.name=='ForgotPassword' || to.name=='admin_sign_in' || to.name=='' || to.name=='register') {
//     next();
//   } else if(to.name!=='auth-login' && !isLoggedIn) {
//     sessionStorage.setItem('redirectPath', to.path);
//     next({ name: 'auth-login' })
//   } else if(to.name!=='auth-login' && isLoggedIn) {
//     next('/dashboard');
//   } else if(to.name=='auth-login' && isLoggedIn) {
//     next()
//   } else if(!to.meta.requiredAuth) {
//     next();
//   }
//   else next();
  
// });

// ? For splash screen
// Remove afterEach hook if you are not using splash screen
router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
})

export default router
